"use strict";

var _regeneratorRuntime = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetUser = exports.withAuth = exports.signUpWithUsernameFields = void 0;

var ui_react_1 = require("@aws-amplify/ui-react");

var react_1 = __importStar(require("react"));

var ui_components_1 = require("@aws-amplify/ui-components");

var aws_amplify_1 = require("aws-amplify");

exports.signUpWithUsernameFields = [{
  type: 'username',
  label: 'Username (your garden address will be based on it) *' // inputProps: {
  //   pattern: "[A-Za-z]{3}",
  //   maxLength: 40
  // type: 'date',
  // }

}, {
  type: 'password'
}, {
  type: 'email'
}];
/**
 * Mostly replicating withAuthenticator from amplify lib, but with custom fields.
 * Haven't found an easier way. If I just wrap component - something weird happens to styling
 */

function withAuth(Component, authenticatorProps) {
  var AppWithAuthenticator = function AppWithAuthenticator(props) {
    var _react_1$useState = react_1.useState(false),
        _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
        signedIn = _react_1$useState2[0],
        setSignedIn = _react_1$useState2[1];

    react_1.default.useEffect(function () {
      // checkUser returns an "unsubscribe" function to stop side-effects
      return checkUser();
    }, []);

    function checkUser() {
      setUser();
      return ui_components_1.onAuthUIStateChange(function (authState) {
        if (authState === ui_components_1.AuthState.SignedIn) {
          setSignedIn(true);
        } else if (authState === ui_components_1.AuthState.SignedOut) {
          setSignedIn(false);
        }
      });
    }

    function setUser() {
      return _setUser.apply(this, arguments);
    }

    function _setUser() {
      _setUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var user;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return aws_amplify_1.Auth.currentAuthenticatedUser();

              case 3:
                user = _context.sent;
                if (user) setSignedIn(true);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
      return _setUser.apply(this, arguments);
    }

    if (!signedIn) {
      return react_1.default.createElement(ui_react_1.AmplifyContainer, null, react_1.default.createElement(ui_react_1.AmplifyAuthenticator, Object.assign({}, authenticatorProps, props), react_1.default.createElement(ui_react_1.AmplifySignUp, {
        slot: "sign-up",
        formFields: exports.signUpWithUsernameFields
      })));
    }

    return react_1.default.createElement(Component, null);
  };

  return AppWithAuthenticator;
}

exports.withAuth = withAuth;

function useGetUser() {
  var _react_1$useState3 = react_1.useState(""),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      user = _react_1$useState4[0],
      setUser = _react_1$useState4[1];

  react_1.useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _user;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return aws_amplify_1.Auth.currentAuthenticatedUser();

            case 3:
              _user = _context2.sent;
              setUser(_user.getUsername());
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log("Can't fetch user", _context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }))();
  }, []);
  return user;
}

exports.useGetUser = useGetUser;